<div class="flex justify-center align-center">
  <mat-spinner [style]="styleStr"></mat-spinner>
</div>
